import { motion } from "framer-motion";
import Marquee from "react-fast-marquee";

const partners = [
  "Harvard", "MIT", "Stanford", "Oxford", "Cambridge", "Yale", "Princeton",
  "Columbia", "Berkeley", "ETH Zurich", "Tokyo University", "Sorbonne",
  "NUS Singapore", "Melbourne", "Toronto", "INSEAD", "LSE", "Imperial"
];

const regions = [
  { name: "North America", count: "80+" },
  { name: "Europe", count: "60+" },
  { name: "Asia Pacific", count: "40+" },
  { name: "Latin America", count: "15+" },
  { name: "Middle East", count: "10+" },
  { name: "Africa", count: "15+" },
];

export const Network = () => {
  return (
    <section
      id="network"
      data-testid="network-section"
      className="py-24 md:py-32 bg-surface-solid relative overflow-hidden"
    >
      {/* Background elements */}
      <div className="absolute top-1/2 left-0 w-[400px] h-[400px] bg-primary/5 rounded-full blur-[150px] pointer-events-none" />
      <div className="absolute bottom-0 right-0 w-[300px] h-[300px] bg-secondary/5 rounded-full blur-[100px] pointer-events-none" />

      <div className="relative z-10 max-w-7xl mx-auto px-6 md:px-12 lg:px-16">
        {/* Section Header */}
        <motion.div 
          initial={{ opacity: 0, y: 30 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.6 }}
          className="text-center max-w-3xl mx-auto mb-16"
        >
          <span className="text-sm uppercase tracking-widest font-semibold text-primary mb-4 block">
            Global Network
          </span>
          <h2
            className="font-heading text-4xl md:text-5xl font-bold tracking-tight text-white mb-6"
            data-testid="network-heading"
          >
            Partnerships That Span the Globe
          </h2>
          <p className="text-lg text-white/60 leading-relaxed">
            We collaborate with leading institutions worldwide to create pathways 
            for education and professional development.
          </p>
        </motion.div>

        {/* Partner Marquee */}
        <div className="mb-16 marquee-fade">
          <Marquee gradient={false} speed={40} className="py-6">
            {partners.map((partner, idx) => (
              <div
                key={idx}
                className="mx-6 px-8 py-4 glass-card rounded-xl"
              >
                <span className="text-white/70 font-semibold text-lg whitespace-nowrap">
                  {partner}
                </span>
              </div>
            ))}
          </Marquee>
          <Marquee gradient={false} speed={30} direction="right" className="py-4">
            {[...partners].reverse().map((partner, idx) => (
              <div
                key={idx}
                className="mx-6 px-8 py-4 glass-card rounded-xl"
              >
                <span className="text-white/70 font-semibold text-lg whitespace-nowrap">
                  {partner}
                </span>
              </div>
            ))}
          </Marquee>
        </div>

        {/* Regional Presence */}
        <motion.div
          initial={{ opacity: 0, y: 30 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.6 }}
          className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-6 gap-4"
        >
          {regions.map((region, idx) => (
            <div
              key={idx}
              data-testid={`region-${idx}`}
              className="text-center p-6 rounded-xl glass-card hover:border-primary/30 card-hover"
            >
              <div className="text-3xl font-heading font-black text-primary mb-1">
                {region.count}
              </div>
              <div className="text-sm text-white/60">
                {region.name}
              </div>
            </div>
          ))}
        </motion.div>
      </div>
    </section>
  );
};
